import {
    HOMEPAGE_SETTINGS_UPLOAD_START,
    HOMEPAGE_SETTINGS_UPLOAD_ERROR,
    HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
} from '../../constants/index'
import { setLoaderStart, setLoaderComplete } from '../loader/loader'
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import { updateHomePageSignup as mutation } from '../../lib/graphql';

export const updateHomepageSettingsSignup = (values) => {

    return async (dispatch, getState, { client }) => {

        try {
            dispatch(setLoaderStart('SignupSettingsForm'))
            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_START
            })

            let title, description;
            title = values?.signupGridTitle1?.length && values?.signupGridTitle1[0]?.value;
            description = values?.signupGridTitle1?.length && values?.signupGridTitle1[0]?.description;

            const { data } = await client.mutate({
                mutation,
                variables: {
                    signupGridImage1: values?.signupGridImage1,
                    signupGridImage2: values?.signupGridImage2,
                    signupGridImage3: values?.signupGridImage3,
                    signupGridTitle1: title,
                    signupGridContent1: description,
                    signupGridLink1: values?.signupGridLink1,
                    signupGridLink2: values?.signupGridLink2,
                    signupGridImage4: values?.signupGridImage4,
                    dynamicAppSettings: values?.signupGridTitle1
                }
            })

            if (data?.updateHomePageSignup?.status == 200) {
                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
                })
                showToaster({ messageId: 'updateCitySuccess', toasterType: 'success' });
            } else {
                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
                })
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updateHomePageSignup?.errorMessage }, toasterType: 'error' });
            }
            dispatch(setLoaderComplete('SignupSettingsForm'))
        } catch (err) {
            dispatch(setLoaderComplete('SignupSettingsForm'))
            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
            })
            showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
        }
    }
}